import { withBase } from 'ufo'
import { crystallizeDefaultFolderSchema } from '~/utils/crystallize/folder'
import { podcastSchema } from '~/utils/crystallize/podcast'

const ROOT_PATH = '/podkaster'

export function usePodcast(slug: MaybeRefOrGetter<string>) {
  const path = computed(() => withBase(toValue(slug), ROOT_PATH))

  const options = useCatalogueQueryOptions({ path, schema: podcastSchema })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}

export function usePodcasts(route?: ReturnType<typeof useRoute>) {
  const options = useCatalogueQueryOptions({ path: ROOT_PATH, route, schema: crystallizeDefaultFolderSchema(podcastSchema) })

  return useQuery({
    ...options,
    staleTime: 1000 * 60 * 60, // 1 hour
  })
}
